import React from 'react'
import { observer } from 'mobx-react'
import { CardContent } from 'components/Card'
import Button from 'components/Button'
import JobProgressionViewModel from '../JobProgressionViewModel'
import TaxExtensionProgressionActions from '../TaxExtensionProgressionActions'

interface Props {
  vm: JobProgressionViewModel
  canCompleteJob?: boolean
}

export default observer(function JobExtensionCompletedProgressionActions({
  vm,
  canCompleteJob,
}: Props) {
  return (
    <>
      {vm.isExtensionRejected &&
        !vm.submittedExtensionConfirmationRejection && (
          <CardContent compactBottomPadding>
            <Button
              type="secondary"
              size="wide-slim"
              onClick={() => vm.viewExtensionDocumentCreationModal()}
              dataTest="job-progression-upload-rejection-confirmation-button"
            >
              Upload Rejection Confirmation
            </Button>
          </CardContent>
        )}

      {!vm.isAnyExtensionFlowAvailable && (
        <CardContent>
          <Button
            type="primary"
            size="wide-slim"
            onClick={() => vm.closeJob()}
            dataTest="job-progression-complete-job-button"
            disabled={
              vm.isExtensionRejected
                ? !(
                    canCompleteJob && vm.submittedExtensionConfirmationRejection
                  )
                : !canCompleteJob
            }
          >
            Complete Job
          </Button>
        </CardContent>
      )}

      {vm.isAnyExtensionFlowAvailable && (
        <TaxExtensionProgressionActions vm={vm} />
      )}
    </>
  )
})
